import Player from "../player";

export const NONE_UNIFORM = "NA";

export default class NoPlayer extends Player {
    constructor(teamId) {
        super(teamId, NONE_UNIFORM, [], "No Player");
        this.playerId = `${NONE_UNIFORM}-${teamId}`;
    }

    static getUniform() {
        return NONE_UNIFORM;
    }
}
